import { render, staticRenderFns } from "./ErrorWriteInBike.vue?vue&type=template&id=21bbd8b5&scoped=true&"
var script = {}
import style0 from "./ErrorWriteInBike.vue?vue&type=style&index=0&id=21bbd8b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbd8b5",
  null
  
)

export default component.exports